<p-calendar
	[dateFormat]="field.UIOptions?.CalendarComponent?.dateFormat"
	[formControl]="control"
	[inline]="true"
	[showWeek]="true" ></p-calendar>
